import { FormEvent } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import "../../scss/sign-up.scss";

import InputField from "./InputField";
import { useSignUpMutation } from "../../store/api/authAPI";

import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import { toast } from "react-hot-toast";

/**
 * @async @function handleSubmit get the input values and pass to the backend for user creation
 * It happens if the passwords match and an entered email doesn't exist,
 * Email existence is checked locally, Email  from  the backend side.
 */

export default function SignUp() {
  const navigate = useNavigate();

  const currentUser = useSelector((state: RootState) => state.auth.user);

  const [signUpFn, { isLoading }] = useSignUpMutation();

  if (currentUser) return <Navigate to="/portal" replace />;

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);
    const firstName = formData.get("first-name")?.toString().trim();
    const lastName = formData.get("last-name")?.toString().trim();
    const email = formData.get("email")?.toString().trim();
    const password = formData.get("password")?.toString();
    const secondPassword = formData.get("second-password")?.toString();

    if (password !== secondPassword) {
      toast.error("Passwords do not match", {
        className: "toast-error",
        duration: 3000,
      });
      return;
    }

    try {
      await signUpFn({
        first_name: firstName!,
        last_name: lastName!,
        email: email!,
        password: password!,
      }).unwrap();

      navigate("/sign-in", { replace: true });
    } catch (e: any) {
      const backendMessage =
        e?.data?.message || "Sign up failed. Please try again.";

      toast.error(backendMessage, {
        duration: 4000,
        className: "toast-error",
      });
    }
  }

  return (
    <>
      <p className="subtitle">
        Enter your details and become a part of our family.
      </p>

      <form id="sign-up-form" onSubmit={handleSubmit}>
        <div className="input-group-container">
          <InputField
            label="First Name"
            id="first-name"
            placeholder="Enter your first name"
            required
          />

          <InputField
            label="Last Name"
            id="last-name"
            placeholder="Enter your last name"
            required
          />
        </div>

        <InputField
          label="Email Address"
          id="email"
          type="email"
          placeholder="Enter your email"
          required
        />

        <InputField
          label="Password"
          id="password"
          type="password"
          placeholder="Enter your password"
          required
        />

        <InputField
          label="Confirm Password"
          id="second-password"
          type="password"
          placeholder="Repeat your password"
          required
        />

        <button type="submit" className="btn-signup">
          {isLoading ? "Creating..." : "Sign Up"}
        </button>

        <div className="extra-links">
          <p>
            Do you have an account? <Link to="/sign-in">Sign In</Link>
          </p>
        </div>
      </form>
    </>
  );
}
